<template>
    <tr>
        <td v-for="(employee, index) in $parent.employees">
            <div @click="createAppointment(employee, time)"
                 :class="{ 'off-hours': isOff(employee, time), 'start': true }"></div>
            <div @click="createAppointment(employee, time + 0.25)"
                 :class="{ 'off-hours': isOff(employee, time + 0.25) }"></div>
            <div @click="createAppointment(employee, time + 0.50)"
                 :class="{ 'off-hours': isOff(employee, time + 0.50) }"></div>
            <div @click="createAppointment(employee, time + 0.75)"
                 :class="{ 'off-hours': isOff(employee, time + 0.75), 'end': true }"></div>
        </td>
    </tr>
</template>

<script>
  export default {
    name: 'Row',
    props: ['time'],
    methods: {
      isOff: function (employee, time) {
        return employee.deleted || !this.$parent.weekDay.on || time < this.$parent.weekDay.start || time > this.$parent.weekDay.end - 0.25
      },
      createAppointment (employee, time) {
        if (this.isOff(employee, time)) {
          return
        }
        this.$emit('create', {
          employee: employee.id,
          start: time
        })
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/timetable/Row.vue